import React, {Component} from 'react';
import {Link} from 'react-router-dom';
import { withTranslate } from 'react-redux-multilingual'
import { portal} from '../../../../config';

class TopBar extends Component {

    render() {
        const {translate} = this.props;
        return (
            <div className="top-header">
                <div className="container">
                    <div className="row">
                        <div className="col-md-6 col-sm-12">
                            <div className="header-contact">
                                <ul>
                                    <li><span className="font-weight-bold">{portal.name}</span></li>
                                    <li><i className="fa fa-phone" aria-hidden="true"></i>{translate('call_us')}:  {portal.support_phone}</li>
                                </ul>
                            </div>
                        </div>
                        <div className="col-lg-6 text-right">
                            <ul className="header-dropdown">
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}


export default withTranslate(TopBar);